var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 45,
    viewBox: "0 0 155 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.2725,
    width: 8.1579,
    height: 32.7273,
    fill: "#00BA37"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2369,
    y: 20.4541,
    width: 8.1579,
    height: 24.5455,
    fill: "#00BA37"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4737,
    y: 36.8184,
    width: 8.1579,
    height: 8.18182,
    fill: "#00BA37"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85.658,
    y: 36.8184,
    width: 8.1579,
    height: 8.18182,
    fill: "#00BA37"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7106,
    y: 16.3633,
    width: 8.1579,
    height: 28.6364,
    fill: "#00BA37"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9473,
    y: 8.18164,
    width: 8.1579,
    height: 36.8182,
    fill: "#00BA37"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 97.8947,
    y: 16.3633,
    width: 8.1579,
    height: 28.6364,
    fill: "#00BA37"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 110.132,
    y: 8.18164,
    width: 8.1579,
    height: 36.8182,
    fill: "#00BA37"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 122.368,
    width: 8.1579,
    height: 45,
    fill: "#00BA37"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 134.605,
    y: 12.2734,
    width: 8.1579,
    height: 32.7273,
    fill: "#00BA37"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 146.842,
    y: 8.18164,
    width: 8.1579,
    height: 36.8182,
    fill: "#00BA37"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1842,
    width: 8.1579,
    height: 45,
    fill: "#00BA37"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4211,
    y: 16.3633,
    width: 8.1579,
    height: 28.6364,
    fill: "#00BA37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.f209b395.svg";
export { ForwardRef as ReactComponent };